import { useIntl } from '@doxyme/locale';
import { NextSeo, NextSeoProps } from 'next-seo';

export type MetaHeadProps = NextSeoProps & {
  withTitleSuffix?: boolean;
};

export const MetaHead = (props: MetaHeadProps) => {
  const { title, withTitleSuffix = true } = props;

  const { formatMessage } = useIntl();

  const defaultTitle = formatMessage({ id: 'doxyme' });

  const parsedTitle =
    withTitleSuffix && title
      ? formatMessage({ id: 'meta.title.with.suffix' }, { title })
      : title;

  return <NextSeo {...props} title={parsedTitle ?? defaultTitle} />;
};
